import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const DbnpRegistriesGSTInfoComponent = ({ handleInnerFormChange, selectedDbnpRegistry }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="Legal Entity Name"
                        name="legal_entity_name"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.legal_entity_name',
                                selectedDbnpRegistry?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.RegConfigGst?.legal_entity_name}
                    />
                    <InputContainer
                        label="Business Address"
                        name="business_address"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.business_address',
                                selectedDbnpRegistry?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.RegConfigGst?.business_address}
                    />
                    <InputContainer
                        label="GST No"
                        name="gst_no"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.gst_no',
                                selectedDbnpRegistry?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.RegConfigGst?.gst_no}
                    />
                    <InputContainer
                        label="City Code"
                        onValueChange={(newValue: any) => {
                            const citycodeData: any = newValue.map((option: any) => option?.id || '')
                            handleInnerFormChange(
                                citycodeData,
                                'RegConfigGst.city_code',
                                selectedDbnpRegistry?.RegConfigGst

                            );
                        }}
                        type="multiselectText"
                        value={selectedDbnpRegistry?.RegConfigGst?.city_code}
                    />
                </div>
            }
            expandedPanel="gst info"
            headerTitle="GST Info"
        />
    </>
)

export default DbnpRegistriesGSTInfoComponent;